export default __webpack_public_path__ + "static/help-guide-c3af1f661aa01802650096fe62ee49b1.png";